/* ============================================================================
   FOOTER — LUXURY (Phase 1)
   - Mobile accordion toggles
   - Reveal on scroll (respects prefers-reduced-motion)
   ============================================================================ */
(function () {
  'use strict';

  const footer = document.querySelector('.footer--luxury');
  if (!footer) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Mobile accordion (only active <= 749px) ---------- */
  const mq = window.matchMedia('(max-width: 749px)');

  const toggles = footer.querySelectorAll('.fl-col__toggle');

  function setPanel(toggle, open) {
    const panelId = toggle.getAttribute('aria-controls');
    if (!panelId) return;
    const panel = footer.querySelector('#' + panelId);
    if (!panel) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.dataset.open = open ? 'true' : 'false';
  }

  function initAccordion() {
    toggles.forEach((toggle) => {
      if (mq.matches) {
        // Collapsed by default on mobile
        if (!toggle.hasAttribute('data-bound')) {
          toggle.setAttribute('data-bound', 'true');
          toggle.addEventListener('click', () => {
            const open = toggle.getAttribute('aria-expanded') === 'true';
            setPanel(toggle, !open);
          });
        }
        if (toggle.getAttribute('aria-expanded') !== 'true') {
          setPanel(toggle, false);
        }
      } else {
        // Desktop: always open
        setPanel(toggle, true);
      }
    });
  }

  initAccordion();
  if (mq.addEventListener) {
    mq.addEventListener('change', initAccordion);
  } else if (mq.addListener) {
    mq.addListener(initAccordion);
  }

  /* ---------- Reveal on scroll ---------- */
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    footer.querySelectorAll('.fl-reveal').forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const reveal = footer.querySelectorAll('.fl-reveal');
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  reveal.forEach((el) => io.observe(el));
})();
